import { CSSProperties, Children, ReactElement, cloneElement } from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

type HorizontalContainerProps = {
  alignItems?: 'stretch' | 'center';
  children: React.ReactNode;
  className?: string;
  gap?: number;
  grid?: number;
  marginBottom?: number;
  style?: CSSProperties;
  wrapperStyles?: SerializedStyles;
};

export const HorizontalContainer = ({
  alignItems = 'stretch',
  className,
  children,
  gap = 24,
  grid = 2,
  marginBottom = 24,
  style,
  wrapperStyles,
  ...rest
}: HorizontalContainerProps) => {
  // This is required to pass props received from parent to children (as this component is a middleman)
  const renderChildren = () => {
    return Children.map(children, (child) => {
      return child ? cloneElement(child as ReactElement, rest) : null;
    });
  };

  return (
    <div
      className={className}
      css={[
        css`
          align-items: ${alignItems};
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          flex: 1;
          gap: ${gap}px;
          justify-content: center;
          margin-bottom: ${marginBottom}px;
          position: relative;

          @container (min-width: ${breakpoints.medium.min}px) {
            flex-direction: row;
          }

          > * {
            flex: 1;
            width: 100%;

            @container (min-width: ${breakpoints.medium.min}px) {
              width: calc(${100 / grid}% - ${theme.spacing(3)});
            }
          }

          > .chart-card {
            margin-bottom: 0 !important;
          }
        `,
        wrapperStyles,
      ]}
      style={style}
    >
      {renderChildren()}
    </div>
  );
};
